import Auth from '@/middleware/auth.middle';
import NonLogin from '@/middleware/non-login.middleware';
import { ReactElement, useMemo } from 'react';
import { useRootSelector } from '@/hooks/selector.hook';

type MiddlewareProps = {
  children: ReactElement;
  fallback?: string;
  mode?: 'public' | 'private' | 'non-login';
};

export default function Middleware({ mode = 'public', children }: MiddlewareProps) {
  const { isAuthenticated, isLoading } = useRootSelector((state) => state.auth);

  const Gateway: any = useMemo(() => {
    if (mode === 'private') return Auth;
    if (mode === 'non-login') return NonLogin;
    return ({ children }: any) => children;
  }, [mode]);

  // Hiển thị loading khi đang check auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return <Gateway logged={isAuthenticated}>{children}</Gateway>;
}
